import {BaseObject} from './BaseObject';
import {User} from './User';

export class Log extends BaseObject {
    id: number;
    objectType: string;
    objectId: number;
    objectAction: string;
    data: string;
    userId: number;
    user: User;
    createdAt: string;
}



// WEBPACK FOOTER //
// /app/src/model/Entities/Log.ts